import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  leave_type_name: yup.string().required(VALIDATION.required).max(150, VALIDATION.max),
  num_of_day: yup.string().required(VALIDATION.required),
  leave_description: yup.string().required(VALIDATION.required).max(150, VALIDATION.max),
})
